import axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';
import { TipsterRoute } from '../CustomRoute/TipsterRoute';

import { ShopContainerConnected } from '../Shops/ShopContainer';
import { StoreTypesReversed } from '../PaymentGateway/interfaces/store_types';

export interface ITipsterRoute {
  tipster_id: string;
  tracker_code: string;
  slug: string;
  secondary_slug?: string;
  is_challenge?: boolean;
}
export const getTipsterRoutes = async (): Promise<
  ITipsterRoute[] | undefined
> => {
  try {
    const response: any = await axios.get('/v1/tipsters/routes');
    const { tipsters_routes } = response;
    return tipsters_routes;
  } catch {
    toast.error('Error processing tipster links');
  }
};

export const createTipsterRoutes = (routes: ITipsterRoute[]) =>
  routes.map(
    (route) =>
      route.slug.length && (
        <TipsterRoute
          component={() => (
            <ShopContainerConnected storeType={StoreTypesReversed.Premium} />
          )}
          tipsterSlug={route.slug}
          path={`/premium/${route.slug}`}
          key={route.slug}
          tipsterID={route.tipster_id}
          adjustTracker={route.tracker_code}
        />
      ),
  );
